import { customAlphabet } from 'nanoid';

export const genId = customAlphabet(
  '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
);

export const genUppercaseId = customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
);

export const shortId = customAlphabet('123456789ABCDEFGHIJKLMNPQRSTUVWXYZ', 11);
export const id = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', 18);

export const gen6DigitSuffix = customAlphabet('0123456789', 6);
